
import swal from 'sweetalert';
import axios from 'axios';



/**
 * 
 * Method for recover passwrod
 * @param {*} param0 
 */

export async function lostPassword({ commit, state }) {}

/**
 * 
 * Method for new passwrod
 * @param {*} param0 
 */

export async function newPassword({ commit, state }, token) {}

/**
 * 
 * Method for new passwrod
 * @param {*} param0 
 */





/**
 * 
 * Method for new passwrod
 * @param {*} param0 
 */

export async function ChangePassword({ commit, state }, body) {}



export async function getAssets({ commit, state,rootState }) { 
    let arrayAsset= [
        259038, // 1
        106504, // 2
        104885,  // 3
        104884, // 4
        104883, // 5
        1131779, // 6
        2927308, // 7
        3410341, // 8
        3597682, // 9
        3682560, // 10
        4759542  //11
    ]
/*     arrayAsset.forEach(async (asset) =>  {
        await InPlayer.Asset.checkAccessForAsset(asset)
        .then(data => { 
            commit('setVali',data.data.item.id)          
            commit('setVal',data.data.item.id)          
        }).catch(e => {})              
    }); */
}

export async function messageOperation() { 
    let uuid = localStorage.getItem('uuid')
/*    InPlayer.subscribe(uuid,{
        onMessage: (message) => {  
            console.log('mess1',message) 
            if(message.includes('payment.card.success')) {
                localStorage.setItem('isReload', true)
                swal({
                    title: 'Payment Success',
                    icon: "success",
                    buttons: false,
                    timer: 10000
                })
            }
            if(message.includes('payment.card.failed')) {
                swal({
                    title: "Payment Failed",
                    text: "Payment Declined.",
                    icon: "error",
                    buttons: false,
                    timer: 10000,
                });
            }
        },onOpen: (e) => console.log('open')  
    });  */
}


/* export async function messageCard() { 
    let uuid = localStorage.getItem('uuid') 
    console.log(uuid)   
    InPlayer.subscribe(uuid, {
        onMessage: function(message) {
            if(message.type==='payment.success') {
                window.location.href=window.location.origin +'/home'
            }
        },onOpen: (e) => console.log('open1111')  
    }); 
} */
// Payment Methods

/**
 * Methos to get payment methods
 * 
 * @param {*} param0 
 */
/* export async function getPayMethods({ commit, state }, id) {
    InPlayer.Payment.getPaymentMethods()
    .then(data =>{ 
        console.log(data)
        commit('getPayMethods', data.data)
    });


} */

/**
 * Methos to get Access Fees 
 * info about asset
 * 
 * @param {*} param0 
 */
/* export async function getAccessFees({ commit, state }, id) {
    await InPlayer.Asset.getAssetAccessFees(id)
    .then(data => {
        commit('getAccessFee', data.data)
    })

} */
